module.exports = __webpack_public_path__ + "static/media/linkedin.1f0b8e89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/linkedin.svg
// module id = 219
// module chunks = 0